export default {
  common: {
    back: 'Quay lại',
    backHome: 'Trở về trang chủ',
    return: 'Trở về',
  },
  route: {
    dashboard: 'Tổng quan',
    factory: 'Xí nghiệp',
    device: 'Danh sách thiết bị',
    camera: 'Danh sách camera',
    station: 'Danh sách trạm',
    area_location_config: 'Thiết lập GIS',
    history: 'Thống kê lịch sử',
    report: 'Báo cáo',
    help: 'Hướng dẫn sử dụng',
    introduction: 'Giới thiệu',
    guide: 'Hướng dẫn',
    administrator: 'Quản lý hệ thống',
    users: 'Quản lý tài khoản',
    rolePermission: 'Quản lý phân quyền',
    work: 'Phiếu công tác',
    keyworks: 'Quản lý từ khóa',
  },
  navbar: {
    logOut: 'Đăng xuất',
    dashboard: 'Bảng điều khiển',
    screenfull: 'Toàn màn hình',
    profile: 'Trang cá nhân',
  },
  login: {
    title: 'ENV',
    systemName: 'ERP MANAGERMENT',
    logIn: 'Đăng nhập',
    username: 'Tài khoản',
    email: 'Email',
    password: 'Mật khẩu',
  },
  panelGroup: {
    diemluutru: 'Điểm lưu trú',
    nguoiluutru: 'Người lưu trú',
    truna: 'Truy nã',
    taikhoan: 'Tài khoản',
    phathientruna: 'Phát hiện truy nã',
    luutrutrongngay: 'Lưu trú trong ngày',
  },
  permission: {
    editPermission: 'Chỉnh sửa quyền',
  },
  table: {
    diadiemluutru: 'Địa điểm lưu trú',
    import: 'Tạo từ excel',
    subjects: 'Môn học',
    description: 'Mô tả',
    name: 'Tên',
    title: 'Tiêu đề',
    importance: 'IMP',
    type: 'Thể loại',
    remark: 'Remark',
    search: 'Tìm kiếm',
    add: 'Tạo mới',
    export: 'Tải về',
    reviewer: 'reviewer',
    id: 'ID',
    date: 'Ngày',
    author: 'Tác giả',
    readings: 'Số lần đọc',
    status: 'Status',
    actions: 'Thao tác',
    edit: 'Sửa',
    permission: 'Phân quyền',
    publish: 'Publish',
    draft: 'Lưu tạm',
    delete: 'Xóa',
    cancel: 'Hủy',
    confirm: 'Xác nhận',
    keyword: 'Từ khóa',
    role: 'Nhóm',
    fromDate: 'Từ ngày',
    toDate: 'Đến ngày',
    module_name: 'Tên chức năng',
  },
  errorLog: {
    e404mess1: 'Vui lòng kiểm tra xem URL bạn đã nhập có đúng không. Vui lòng nhấp vào nút bên dưới để quay lại trang chủ hoặc gửi báo cáo lỗi.',
    e404mess2: 'Hệ thống cảnh báo bạn không vào được trang này...',
  },
  excel: {
    export: 'Export',
    selectedExport: 'Export Selected Items',
    placeholder: 'Please enter the file name(default excel-list)',
  },
  zip: {
    export: 'Export',
    placeholder: 'Please enter the file name(default file)',
  },
  pdf: {
    tips: 'Here we use window.print() to implement the feature of downloading pdf.',
  },
  theme: {
    change: 'Change Theme',
    documentation: 'Theme documentation',
    tips: 'Tips: It is different from the theme-pick on the navbar is two different skinning methods, each with different application scenarios. Refer to the documentation for details.',
  },
  tagsView: {
    refresh: 'Refresh',
    close: 'Close',
    closeOthers: 'Close Others',
    closeAll: 'Close All',
  },
  user: {
    'role': 'Nhóm',
    'password': 'Mật khẩu',
    'confirmPassword': 'Nhập lại mật khẩu',
    'name': 'Tên',
    'email': 'Địa chỉ email',
    'school': 'Trường',
  },
  roles: {
    description: {
      admin: 'Quản trị viên cấp cao. Có quyền truy cập và toàn quyền vào tất cả các trang.',
      manager: 'Quản trị viên. Có quyền truy cập và quyền đối với hầu hết các trang ngoại trừ trang quyền.',
      editor: 'Biên tập viên. Có quyền truy cập vào hầu hết các trang, toàn quyền với các bài báo và tài nguyên liên quan.',
      user: 'Người dùng bình thường. Có quyền truy cập vào một số trang',
      visitor: 'Khách thăm quan. Có quyền truy cập vào các trang tĩnh, không được có bất kỳ quyền có thể ghi nào',
    },
  },
};
